import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InnovationheadingListComponent } from './innovationheading-list/innovationheading-list.component';
import { InnovationheadingCreateComponent } from './innovationheading-create/innovationheading-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: InnovationheadingListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: InnovationheadingCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'innovation-heading-create/:id',
        component: InnovationheadingCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class InnovationHeadingRoutingModule { }
